// MobileWall.jsx
import { useEffect, useState } from "react";
import { __, ____ } from "../../utils";
import { mainStore } from "../../store";

export default function MobileWall() {
    const [isMobile, setIsMobile] = useState(false);
    const [isPortrait, setIsPortrait] = useState(false);

    const lang = mainStore.useStore(s => s.lang)

    // Vérifie si l'appareil est un mobile
    const detectMobile = () => {
        const userAgent = navigator.userAgent || navigator.vendor || window.opera;
        const isMobileUA = /android|iphone|ipad|ipod|blackberry|iemobile|opera mini/i.test(userAgent.toLowerCase());
        const isMobileViewport = window.innerWidth <= 768;
        return isMobileUA || isMobileViewport;
    };

    useEffect(() => {
        const handleResize = () => {
            setIsMobile(detectMobile());
            setIsPortrait(window.innerHeight > window.innerWidth);
        };

        handleResize(); // Initial check
        window.addEventListener("resize", handleResize);
        window.addEventListener("orientationchange", handleResize);

        return () => {
            window.removeEventListener("resize", handleResize);
            window.removeEventListener("orientationchange", handleResize);
        };
    }, []);

    if (!(isMobile && isPortrait)) return null;

    return <>
        <div style={overlayStyle}>
            <div style={textContainer}>
                <h1>{____(lang, "Bienvenue !", "Welcome!")}</h1>
                <div style={{ marginBottom: '1.5rem' }}>
                    <svg xmlns="http://www.w3.org/2000/svg" width="64" height="64" viewBox="0 0 24 24"><path fill="currentColor" d="M9 1H3a2 2 0 0 0-2 2v13a2 2 0 0 0 2 2h6a2 2 0 0 0 2-2V3a2 2 0 0 0-2-2m0 14H3V3h6zm12-2h-8v2h8v6H9v-1H6v1a2 2 0 0 0 2 2h13a2 2 0 0 0 2-2v-6a2 2 0 0 0-2-2m2-3l-4-2l1.91-.91A7.52 7.52 0 0 0 14 2.5V1a9 9 0 0 1 9 9" /></svg>
                </div>
                <p style={textStyle}>
                    {
                        ____(
                            lang,
                            <>
                                <strong>Cette expérience a été pensée pour être visionnée depuis un ordinateur.</strong>
                                <br />
                                <br />
                                L'affichage sur mobile est limité. Si vous souhaitez toutefois la consulter sur format mobile, tournez votre écran pour une meilleure lecture.
                                <br />
                                <br />
                                Merci de votre compréhension !
                            </>,
                            <>
                                <strong>This experience has been designed to be viewed from a computer.</strong>
                                <br />
                                <br />
                                Mobile viewing is limited. However, if you wish to visit it on a mobile device, please turn your screen so that it reads better.
                                <br />
                                <br />
                                Thank you for your understanding!
                            </>

                        )

                    }

                </p>
            </div>
        </div>
    </>
}

// Styles inline pour éviter les imports CSS
const overlayStyle = {
    position: "fixed",
    top: 0,
    left: 0,
    width: "100vw",
    height: "100vh",
    backgroundColor: "rgba(0,0,0,0.9)",
    zIndex: 9999,
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    textAlign: "center",
};

const textContainer = {
    color: "white",
    fontSize: "1rem",
    fontWeight: "",
    padding: "2rem"
};

const textStyle = {
    margin: 0,
};
